import { styled } from '@material-ui/core/styles';
import { ICustomTheme } from 'interfaces';
import AppLogo from 'components/layouts/AppLogo';

export const StyledLegalsContainer = styled('div')(
  ({ theme, isDesktop }: { theme: ICustomTheme; isDesktop: boolean }) => ({
    padding: isDesktop ? theme.spacing(4, 10) : theme.spacing(2, 2, 14, 2), // this padding bottom should be retained as it provides for bottom navigation in the mobile version
    display: 'flex',
    flexDirection: isDesktop ? 'row' : 'column',
    justifyContent: isDesktop ? 'space-between' : 'center',
    alignItems: 'center',
    gap: theme.spacing(2),
    backgroundColor: theme.palette.grey[200],
  }),
);

export const StyledAppLogo = styled(AppLogo)(() => ({
  maxHeight: '15rem',
  maxWidth: '50rem',
  width: 'auto',
}));
